import React from 'react';
import { Grid } from '@material-ui/core';
import Home from 'components/Home'
import CardPautaProgramacao from 'components/CardPautaProgramacao';
// import FiquePorDentro from 'components/FiquePorDentro'
import Noticias from 'components/Noticias'
import CookieBanner from 'components/Cookies';

function Inicio() {

    return (
        <>

            <Grid container
                style={{
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                    MozUserSelect: 'none'
                }}>
                <Home />
                <CardPautaProgramacao />
                <CookieBanner />
                {/* <FiquePorDentro /> */}
                <Noticias />
            </Grid>

        </>
    )
}

export default Inicio
